import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { APP_TEXTS } from '@texts';

const OTHER = 'other';

export default class SelectWithOther extends Component {

  static propTypes = {
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      isOther: false
    };
  }

  render() {
    return (
      <div className={this.props.className}>
        <select onChange={this.onChange} disabled={this.props.disabled && "disabled"}>
          {this.props.options.map(item => (
            <option key={item.value} value={item.value} selected={item.active ? "selected" : ""}>
              {item.name}
            </option>
          ))}
          <option value={OTHER}>{APP_TEXTS.OTHER_LABEL.Content}</option>
        </select>

        {this.state.isOther && (
          <input 
            onInput={e => this.props.onChange(e.target.value)}
            type="number" 
            lang="fr"
            disabled={this.props.disabled && "disabled"}/>
        )}
      </div>
    );
  }

  onChange = (e) => {
    if (e.target.value === OTHER) {
      this.props.onChange('');

      this.setState({
        isOther: true
      });
    } else {
      this.props.onChange(e.target.value);

      this.setState({
        isOther: false
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/SelectWithOther/index.js